import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './app/services/auth.service';
import { Router } from '@angular/router';

import { INTERCEPTOR_SKIP } from './app/http.context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    const router = inject(Router)

    if (req.context.get(INTERCEPTOR_SKIP)) {
        return next(req); // Skip this interceptor
  }

    return next(req).pipe(
        catchError((error) => {
            if (error.status === 401) {
                console.error("Unauthorized")
                authService.logout();
                router.navigate(['/auth/main'])
            } else if (error.status === 403) {
                console.error('Forbidden - you don’t have permission');
            } else if (error.status === 404) {
                console.error('Not Found - invalid URL');
            } else if (error.status >= 500) {
                console.error('Server Error - try again later');
            }

            // Always rethrow so components can handle it too
            return throwError(() => error);
        })
    );
};